<template>
  <div
    class="btn-login"
    style="
      width: 100vw;
      height: 100vh;
      margin-top: -50px;
      background-size: 100%;
      border-radius: 0px;
    "
  >
    <div
      style="
        width: 394.64px;
        background-color: #ffffff;
        margin: auto;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        padding-bottom: 20px;
      "
    >
      <div
        v-if="forICTDongnai"
        style="
          padding-top: 70px;
          width: auto;
          display: flex;
          justify-content: space-around;
        "
      >
        <img src="../../assets/icons/sub_logo.svg" style="margin-top: 30px" />
        <!-- <img src="../../assets/sidebar_icon/logo-without-text.svg" style="margin-top: 30px"/> -->
      </div>
      <div
        v-else
        style="
          padding-top: 70px;
          width: auto;
          display: flex;
          justify-content: space-around;
        "
      >
        <img
          src="../../assets/sidebar_icon/Logo-text.svg"
          style="margin-top: 30px"
        />
      </div>
      <h3 style="margin-top: 70px; font-weight: bold">
        {{ $t("checkLogin.meetingRoomsWithoutPaper") }}
      </h3>
      <!-- Login form -->
      <div v-if="status" style="margin-top: 20px">
        <form style="width: 80%; margin: auto">
          <div class="form-group">
            <i class="fas fa-check" style="font-size: 100px; color: #26BA50"></i>
          </div>
          <div class="form-group">
            <h1>{{ $t('register.emailTitleC1') }}</h1>
            <p>{{ $t('register.emailTitleC2' ) }}</p>
            <p>{{ $t('register.emailTitleC3' ) }}</p>
          </div>
          <button
            type="submit"
            class="btn-login btn mt-2"
            style="width: 100%; color: #ffffff;"
            v-on:click.stop.prevent="clickOpenLogin"
          >
            {{ $t("login.title") }}
          </button>
        </form>
      </div>
      <div v-else style="margin-top: 20px">
        <form style="width: 80%; margin: auto">
          <div class="form-group">
            <i class="fas fa-times" style="font-size: 100px; color: #DE253A"></i>
          </div>
          <div class="form-group">
            <h1 class="font-weight-bold">{{ $t('register.emailTitleC4') }}</h1>
            <p>{{ $t('register.emailTitleC5' ) }}</p>
            <p>{{ $t('register.emailTitleC3' ) }}</p>
          </div>
          <button
            type="submit"
            class="btn-login btn mt-2"
            style="width: 100%; color: #ffffff;"
            v-on:click.stop.prevent="checkForm"
          >
            {{ $t("checkLogin.continue") }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { isCookieEnabled, getCookie } from "tiny-cookie";

export default {
  name: "EmailActivated",
  data() {
    return {
      uidb64: null,
      token: null,
      status: true,
      forICTDongnai: process.env.VUE_APP_IS_FOR_DONGNAI === "true",
    };
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["ACCOUNT_EMAIL_ACTIVATED", "ON_SHOW_TOAST", "LOGOUT"]),

    clickOpenLogin: function () {
      this.$router.push({
        name: "checkLogin",
      });
    },
    signOut() {
      let id_token = isCookieEnabled() ? getCookie("id_token") : null;
      if (id_token) {
        sessionStorage.clear();
        this.LOGOUT(id_token)
          .then(function () {}.bind(this))
          .catch(function () {}.bind(this));
      }
    },
  },
  components: {},
  mounted() {
    this.signOut();
    let body = document.getElementsByTagName("BODY")[0];
    body.className = "login-page hold-transition";
    this.uidb64 = this.$route.params.uidb64;
    this.token = this.$route.params.token;

    let payload = {
      uidb64: this.uidb64,
      token: this.token,
    };
    this.ACCOUNT_EMAIL_ACTIVATED(payload)
      .then(
        function () {
          // this.$router.push({ name: "Login" });
          this.status = true;
        }.bind(this)
      )
      .catch(
        function (error) {
          this.ON_SHOW_TOAST({
            message: error.response.data.message,
            styleType: "danger",
          });
          this.status = false;
        }.bind(this)
      );
  },
};
</script>

<style lang="scss" scoped>
@import "../../style/color.scss";
.login-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.btn-login {
  background: -moz-linear-gradient(bottom, $light-primary 100%, $primary 100%);
  background: -o-linear-gradient(bottom, $light-primary 100%, $primary 100%);
  background: -ms-linear-gradient(bottom, $light-primary 100%, $primary 100%);
  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.3, $light-primary),
    color-stop(0.7, $primary)
  );
  border-radius: 5px;
}
h1 {
  margin: 0 0 20px;
  font-weight: 300;
  font-size: 20px;
  color: #666;
}
</style>